/* app/ui/header/load */

define(
	'app/ui/header/load',[
		'jquery',
		'app/ui/header/sticky',
		'app/ui/header/menu',
		'app/ui/header/search',
		'pubsub'
	],
	function($, HeaderSticky, HeaderMenu, HeaderSearch) {

		var $body = $('body');

		var sharedClasses = {
			dropdownOpen: 'js-dropdown-open',
			headerUp: 'is-up',
			headerDown: 'is-down',
			expanded: 'is-expanded',
			collapsed: 'is-collapsed',
			scrolling: 'is-scrolling',
			sticky: 'is-sticky'
		};

		function updateBodyClass(data) {
			$body[data.transform](sharedClasses.dropdownOpen);
		}

		$.subscribe('/header/toggleDropdown', updateBodyClass);

		HeaderSticky.init($body, sharedClasses);
		HeaderMenu.init(sharedClasses);
		HeaderSearch.init(sharedClasses);
	}
);
